import React, { useState, useEffect } from "react";
import { FiLogOut, FiMenu } from "react-icons/fi";
import PdfHistoryDrawer from "./PdfHistoryDrawer";
import ProfileModal from "./ProfileModal";
import { BiUpload } from "react-icons/bi";
import { AiFillHome, AiFillSetting } from "react-icons/ai";
import { FaArrowAltCircleLeft, FaYoutube } from "react-icons/fa";
import { SiMicrosoftexcel } from "react-icons/si";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { toast } from "../../utils/appToast";
import { CgDatabase } from "react-icons/cg";
import drawer from "../../Images/Frame.jpg";
import circle from "../../Images/Ellipse 1.jpg";
import SliderLogo from "../../Images/logo-sidebar.png";
import profile from "../../Images/profile.png";
import arrowUp from "../../Images/arrow_up.png";
import AIlogo from "../../Images/ai-01.png";
import axios from "axios";

import ContractLogo from "../../Images/contractLogo.png";
import InvoiceLogo from "../../Images/invoiceLogo.png";
import SpreadsheetLogo from "../../Images/spreadSheetLogo.png";
import Cookies from "js-cookie";

import api from "../chat/api";
import { getOrFetchSubscriptionStatus } from "../../utils/subscriptionStatus";
import AICopilotIcon from "../../Images/ai-copiot-icon.svg";
import FilledAICopilotIcon from "../../Images/ai-copilot-icon-filled.svg";
import DocumentsIcon from "../../Images/documents.svg";
import ContractsIcon from "../../Images/contracts-icon.svg";
import ContractsIconFilled from "../../Images/contracts-filled.svg";
import DocumentsIconfilled from "../../Images/documentsfilled.svg";
import TogglemenuClosed from "../../Images/togglemenu.svg";

const navItems = [
  {
    title: "AI Copilot",
    icon: <img src={AICopilotIcon} alt="AI logo" />,
    filledIcon: <img src={FilledAICopilotIcon} alt="AI logo active" />,
    link: "/ai-copilot",
  },
  {
    title: "Documents",
    icon: <img src={DocumentsIcon} alt="document logo" />,
    filledIcon: <img src={DocumentsIconfilled} alt="document logo active" />,
    link: "/uploadFile",
    subMenu: [
      {
        title: "Contracts",
        link: "/contract",
        icon: <img src={ContractsIcon} alt="Contracts logo" />,
        filledIcon: (
          <img src={ContractsIconFilled} alt="Contracts logo active" />
        ),
      },
      {
        title: "Invoices",
        link: "/Invoices",
        icon: <img src="/invoice_unfilled-icon.svg" alt="Invoice logo" />,
        filledIcon: (
          <img src="/invoice_filled-icon.svg" alt="Invoice logo active" />
        ),
      },
      {
        title: "Spreadsheets",
        link: "/Spreadsheet",
        icon: <img src="/spreadsheets.svg" alt="Spreadsheet logo" />,
        filledIcon: (
          <img src="/spreadsheets_filled.svg" alt="Spreadsheet logo active" />
        ),
      },
    ],
  },
  {
    title: "Identity Extraction",
    link: "/Ocr_Data",
    icon: (
      <img
        src="/ocr_filled-icon.svg"
        alt="Identity Extraction logo"
        style={{
          filter: "brightness(80%)",
          opacity: 0.8,
        }}
      />
    ),
    filledIcon: (
      <img
        src="/ocr_filled-icon.svg"
        alt="Identity Extraction logo filled"
        style={{
          filter: "brightness(120%)",
        }}
      />
    ),
  },
  {
    title: "Tags",
    link: "/Tags",
    icon: (
      <img
        src="/tagsfilled-icon.svg"
        alt="Tags logo"
        style={{
          filter: "brightness(80%)",
          opacity: 0.8,
        }}
      />
    ),
    filledIcon: (
      <img
        src="/tagsfilled-icon.svg"
        alt="Tags logo filled"
        style={{
          filter: "brightness(120%)",
        }}
      />
    ),
  },

  {
    title: "Extractor Studio",
    link: "/extractor",
    icon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#F5F4F3" strokeWidth="1.8" opacity="0.6">
        <rect x="3" y="3" width="14" height="16" rx="1" fill="none" stroke="currentColor" />
        <path d="M7 7h8M7 11h8M7 15h5" stroke="currentColor" strokeLinecap="round" />
        <path d="M18 8l2 2M20 8l-2 2M18 14l2 2M20 14l-2 2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    filledIcon: (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#F5F4F3" strokeWidth="2">
        <rect x="3" y="3" width="14" height="16" rx="1" fill="rgba(245, 244, 243, 0.1)" stroke="currentColor" />
        <path d="M7 7h8M7 11h8M7 15h5" stroke="currentColor" strokeLinecap="round" />
        <path d="M18 8l2 2M20 8l-2 2M18 14l2 2M20 14l-2 2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
  },
  
  {
    title: "Rfp Manager",
    icon: (
      <img
        src="/tagsfilleds-icon.svg"
        alt="Tags logo"
        style={{ filter: "brightness(80%)", opacity: 0.8 }}
      />
    ),
    filledIcon: (
      <img
        src="/tagsfilleds-icon.svg"
        alt="Tags logo filled"
        style={{ filter: "brightness(120%)" }}
      />
    ),
    link: "/rfp-dashboard",
    requiresAccess: true, // optional, just for internal clarity
    subMenu: [
      {
        title: "Knowledge Base",
        link: "/rfp-knowledgeBase",
        icon: (
          <img
            src="/tagsfilledssj-icon.svg"
            alt="Tags logo"
            style={{ filter: "brightness(80%)", opacity: 0.8 }}
          />
        ),
        filledIcon: (
          <img
            src="/tagsfilledssj-icon.svg"
            alt="Tags logo filled"
            style={{ filter: "brightness(160%)" }}
          />
        ),
      },
      {
        title: "Projects",
        link: "/rfp-projects",
        icon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14" fill="none">
          <path d="M1.66667 13.3333C1.20833 13.3333 0.815972 13.1701 0.489583 12.8438C0.163194 12.5174 0 12.125 0 11.6667V1.66667C0 1.20833 0.163194 0.815972 0.489583 0.489583C0.815972 0.163194 1.20833 0 1.66667 0H5.97917C6.20139 0 6.41319 0.0416667 6.61458 0.125C6.81597 0.208333 6.99306 0.326389 7.14583 0.479167L8.33333 1.66667H15.8333C16.0694 1.66667 16.2674 1.74653 16.4271 1.90625C16.5868 2.06597 16.6667 2.26389 16.6667 2.5C16.6667 2.73611 16.5868 2.93403 16.4271 3.09375C16.2674 3.25347 16.0694 3.33333 15.8333 3.33333H7.64583L5.97917 1.66667H1.66667V11.6667L3.3125 6.1875C3.42361 5.82639 3.62847 5.53819 3.92708 5.32292C4.22569 5.10764 4.55556 5 4.91667 5H15.6667C16.2361 5 16.684 5.22569 17.0104 5.67708C17.3368 6.12847 17.4236 6.61806 17.2708 7.14583L15.7708 12.1458C15.6597 12.5069 15.4549 12.7951 15.1562 13.0104C14.8576 13.2257 14.5278 13.3333 14.1667 13.3333H1.66667ZM3.41667 11.6667H14.1667L15.6667 6.66667H4.91667L3.41667 11.6667Z" fill="#F5F4F3" fill-opacity="0.6"/>
        </svg>
        ),
        filledIcon: (
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" viewBox="0 0 18 14" fill="none">
          <path d="M1.66667 13.3333C1.20833 13.3333 0.815972 13.1701 0.489583 12.8438C0.163194 12.5174 0 12.125 0 11.6667V1.66667C0 1.20833 0.163194 0.815972 0.489583 0.489583C0.815972 0.163194 1.20833 0 1.66667 0H5.97917C6.20139 0 6.41319 0.0416667 6.61458 0.125C6.81597 0.208333 6.99306 0.326389 7.14583 0.479167L8.33333 1.66667H15.8333C16.0694 1.66667 16.2674 1.74653 16.4271 1.90625C16.5868 2.06597 16.6667 2.26389 16.6667 2.5C16.6667 2.73611 16.5868 2.93403 16.4271 3.09375C16.2674 3.25347 16.0694 3.33333 15.8333 3.33333H7.64583L5.97917 1.66667H1.66667V11.6667L3.3125 6.1875C3.42361 5.82639 3.62847 5.53819 3.92708 5.32292C4.22569 5.10764 4.55556 5 4.91667 5H15.6667C16.2361 5 16.684 5.22569 17.0104 5.67708C17.3368 6.12847 17.4236 6.61806 17.2708 7.14583L15.7708 12.1458C15.6597 12.5069 15.4549 12.7951 15.1562 13.0104C14.8576 13.2257 14.5278 13.3333 14.1667 13.3333H1.66667ZM3.41667 11.6667H14.1667L15.6667 6.66667H4.91667L3.41667 11.6667Z" fill="#F5F4F3"/>
        </svg>
        ),
      },
      // {
      //   title: "Your RFP's",
      //   link: "/rfp-analyze",
      //   icon: (
      //     <img
      //       src="/tags-fls.svg"
      //       alt="Tags logo"
      //       style={{ filter: "brightness(80%)", opacity: 0.8 }}
      //     />
      //   ),
      //   filledIcon: (
      //     <img
      //       src="/tags-fls.svg"
      //       alt="Tags logo filled"
      //       style={{ filter: "brightness(160%)" }}
      //     />
      //   ),
      // },
      // {
      //   title: "Response Writer",
      //   link: "/Response_Writer",
      //   icon: (
      //     <img
      //       src="/tagsfilledssss-icon.svg"
      //       alt="Tags logo"
      //       style={{ filter: "brightness(80%)", opacity: 0.8 }}
      //     />
      //   ),
      //   filledIcon: (
      //     <img
      //       src="/tagsfilledssss-icon.svg"
      //       alt="Tags logo filled"
      //       style={{ filter: "brightness(160%)" }}
      //     />
      //   ),
      // },
    ],
  },
  
];

const Menu = ({ isOpen, toggleMenu, setDisplayName }) => {
  const location = useLocation();
  const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
  const [dynamicNavItems, setDynamicNavItems] = useState([]);

  const [isPdfHistoryDrawerOpen, setPdfHistoryDrawerOpen] = useState(false);
  const [activeItem, setActiveItem] = useState("AI Copilot");
  const [user, setUser] = useState({
    fullName: "",
    email: "",
    username: "",
  });
  const [isShowPaymentPopup, setIsShowPaymentPopup] = useState(false);
  const [showGetStarted, setShowGetStarted] = useState(false);

  const [isContractChat, setIsContractChat] = useState(false);
  const [isCreatedProposal, setIsCreatedProposal] = useState(false);
  const [isExcelChat, setIsExcelChat] = useState(false);
  const [isChatPage, setIsChatPage] = useState(false);
  const [isFolderPage, setIsFolderPage] = useState(false);
  const [isCopilotPage, setIsCopilotPage] = useState(false);
  const pathname = location.pathname.toLowerCase();
  const [hoveredItem, setHoveredItem] = useState(null);
  const [isInvoiceChat, setIsInvoiceChat] = useState(false);
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [uploadedDocsCount, setUploadedDocsCount] = useState(0);
  const [expiresOn, setExpiresOn] = useState("");
  const [selectedPlan, setSelectedPlan] = useState("Grow"); // or "Start" based on logic
  const [isTrialActive, setIsTrialActive] = useState(true);
  const [popupType, setPopupType] = useState("payment");
  const [isPaidYearlyPlan, setIsPaidYearlyPlan] = useState(false);
  const [daysLeft, setDaysLeft] = useState(0);
  const [openSubMenuIndex, setOpenSubMenuIndex] = useState(null);

  const handleSubMenuToggle = (index) => {
    setOpenSubMenuIndex(openSubMenuIndex === index ? null : index);
  };

  const isActive = (link) => {
    const path = location.pathname.toLowerCase();
    const normalizedLink = link.toLowerCase();

    // Exact match or startsWith match
    if (path === normalizedLink || path.startsWith(normalizedLink)) return true;

    // Special mapping for dynamic "create-proposal-question" routes
    if (
      normalizedLink === "/response_writer" &&
      path.startsWith("/create-proposal-question")
    ) {
      return true;
    }

    return false;
  };

  const getParentIndex = (link) => {
    const path = link.toLowerCase();

    // Find parent for submenus normally
    const parentIndex = navItems.findIndex(
      (item) =>
        item.subMenu &&
        item.subMenu.some(
          (sub) =>
            path === sub.link.toLowerCase() ||
            path.startsWith(sub.link.toLowerCase())
        )
    );

    if (parentIndex !== -1) return parentIndex;

    if (path.startsWith("/create-proposal-question")) {
      return navItems.findIndex((item) => item.title === "Rfp Manager");
    }

    return -1;
  };

  const hasRfpAccess = () => {
    const devUIDs = [4, 264, 15, 206, 7, 8, 163, 223, 357, 451, 364];
    const sub = subscriptionStatus;
    return (
      (sub?.subscription_type === "marketers_subs" &&
        sub?.plan_type === "marketers_plan" &&
        sub?.api_key_active === false) ||
      devUIDs.includes(sub?.uid)
    );
  };

  useEffect(() => {
    const parentIndex = getParentIndex(location.pathname);
    if (parentIndex !== -1) {
      setOpenSubMenuIndex(parentIndex);
    }
  }, [location.pathname]);

  const handleItemClick = (index, link) => {
    // 1. Toggle the sub-menu visibility
    setOpenSubMenuIndex(openSubMenuIndex === index ? null : index);

    // 2. You can navigate here using a hook from a router library if needed,
    // though the <Link> component will often handle this.
    // For this example, we'll let the <Link> component handle the navigation.
  };
  
  useEffect(() => {
    const fetchSubscriptionStatus = async () => {
      console.log("Calling API...");

      try {
        const response = await getOrFetchSubscriptionStatus(api);
        if (response.status === 200) {
          const data = response.data;
          setSubscriptionStatus(data);

          // --- Dev UIDs ---
          const devUIDs = [4, 264, 15, 206, 7, 8, 163, 223, 357, 451, 364];

          // --- Condition for marketers_subs OR dev users ---
          if (
            (data.subscription_type === "marketers_subs" &&
              data.plan_type === "marketers_plan" &&
              data.api_key_active === false) ||
            devUIDs.includes(data.uid)
          ) {
          }
        }
      } catch (error) {
        console.error("Error fetching subscription status:", error);
      }
    };

    fetchSubscriptionStatus();
  }, []);

  useEffect(() => {
    const full_name =
      localStorage.getItem("full_name") || localStorage.getItem("fullName");

    const email = localStorage.getItem("email");
    const username = localStorage.getItem("username");

    setUser({
      full_name,
      email,
      username,
    });
    // Ensure setDisplayName exists before calling
    if (typeof setDisplayName === "function") {
      setDisplayName(full_name || username);
    }
  }, [setDisplayName]);

  const handleIconClick = (to) => {
    if (to) {
      navigate(to);
    }
  };
  
  useEffect(() => {
    const pathname = location.pathname;
    if (pathname === "/ai-copilot" || pathname === "/ai-copilot/") {
      setActiveItem("AI Copilot");
      return;
    }
    let currentItem = navItems.find((item) => {
      if (!item.to) return false;
      return pathname === item.to || pathname.startsWith(item.to);
    });
    if (pathname.startsWith("/folder")) {
      currentItem = navItems.find((item) => item.name === "Documents");
    }
    if (currentItem) {
      setActiveItem(currentItem.name);
    } else {
      setActiveItem(null);
    }
  }, [location]);

  // useEffect(() => {
  //   const pathname = location.pathname.toLowerCase();
  //   setIsContractChat(pathname.includes("contractchat"));
  //   setIsChatPage(pathname.includes("/chat"));
  //   setIsInvoiceChat(pathname.includes("/invoices/invoice_chat"));
  //   setIsExcelChat(pathname.includes("/spreadsheets/excelchat"));
  //   setIsFolderPage(pathname.includes("/folder"));
  //   setIsCopilotPage(pathname.includes("/ai-copilot"));
  //   setIsCreatedProposal(
  //     pathname.includes("/created-proposal-finalpage") ||
  //       pathname.includes("/created_proposal")
  //   );
  // }, [location]);
  useEffect(() => {
    const pathname = location.pathname.toLowerCase();
  
    setIsContractChat(pathname.includes("contractchat"));
    setIsChatPage(
      pathname.includes("/chat") ||
      pathname === "/rfp-knowledgebase/chat"
    );
    setIsInvoiceChat(pathname.includes("/invoices/invoice_chat"));
    setIsExcelChat(pathname.includes("/spreadsheets/excelchat"));
    setIsFolderPage(pathname.includes("/folder"));
    setIsCopilotPage(pathname.includes("/ai-copilot"));
    setIsCreatedProposal(
      pathname.includes("/created-proposal-finalpage") ||
      pathname.includes("/created_proposal")
    );
  }, [location]);
  
  const [isCompact, setIsCompact] = useState(false);

  const isRestrictedRoute = /\/(chat|Invoice_chat|folder|contractchat)/i.test(
    location.pathname.toLowerCase()
  );

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handlePdfHistoryDrawerOpen = () => {
    setPdfHistoryDrawerOpen(true);
  };

  const displayName = `${user.full_name || user.username}`.trim();

  let isClicked = false;

  const [isPopupOpen, setIsPopupOpen] = useState(true);

  const handleClose = () => {
    setIsPopupOpen(false);
  };

  // Open the menu (if closed) and navigate to the item's page.
  // For "Documents" and "Rfp Manager", don't expand submenus — just go to parent page.
  const openMenuAndGo = (item, index) => {
    if (!isOpen) toggleMenu();

    // If RFP requires access but the user doesn't have it, prevent click
    if (item.title === "Rfp Manager" && !hasRfpAccess()) {
      toast.warning("This feature is available only in the demo plan.");
      return;
    }

    if (item.link) {
      navigate(item.link);
    }
  };

  const navigate = useNavigate();
  const [clickedBox, setClickedBox] = useState(null);

  const boxItems = [
    {
      id: 3,
      label: "Settings",
      icon: "/account-icon.svg",
      style: {
        marginTop: "130px",
      },
    },
    {
      id: 4,
      label: "Logout",
      icon: "/logout-icon.svg",
      style: {
        marginTop: "130px",
      },
    },
  ];
  
  const logout = () => {
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith("rzp_")) {
        localStorage.removeItem(key);
      }
    });

    document.cookie.split(";").forEach((cookie) => {
      const name = cookie.split("=")[0].trim();
      if (name.startsWith("rzp_")) {
        document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
      }
    });
    Cookies.remove("invitation_token");
    localStorage.removeItem("full_name");
    localStorage.removeItem("email");
    localStorage.removeItem("username");
    localStorage.removeItem("token");
    Cookies.remove("access_token");
    Cookies.remove("refresh_token");
    Cookies.remove("subscription_status");
    localStorage.clear();
    sessionStorage.clear();
    sessionStorage.clear();
    navigate("/signin", { replace: true });
  };

  const handleLogout = () => {
    logout(navigate);
  };
  
  useEffect(() => {
    if (isOpen) {
      setIsPopupOpen(true);
    } else {
      setIsPopupOpen(false);
    }
  }, [isOpen]);

  const handleBoxClick = (index) => {
    if (boxItems[index].label === "Logout") {
      handleLogout();
    } else if (boxItems[index].label === "Settings") {
      navigate("/account");
    } else {
      setClickedBox(index);
    }
  };

  if (isChatPage) {
    return null;
  }
  if (isCreatedProposal) {
    return null;
  }
  if (location.pathname === "/payment") {
    return null;
  }
  if (location.pathname === "/Rfp/Rfp_chat") {
    return null;
  }

  if (isContractChat) {
    return null;
  }
  if (isExcelChat) {
    return null;
  }

  if (isInvoiceChat) {
    return null;
  }

  const isFolderChat = location.pathname === "/Contract/FolderChat";

  if (isFolderChat) {
    return null;
  }

  return (
    <div className=" h-full md:h-screen  bg-[#2C1338]">
      <nav
        className={`bg-[#2C1338] transition-all ${
          isOpen ? "w-65" : "w-[80px]"
        } h-full  fixed z-50 top-0 left-0 flex flex-col justify-between`}
      >
        <div>
          <div className={` ${isOpen ? "" : ""}  `}>
            {isOpen ? (
              <div>
                <div className="flex items-center justify-between gap-6">
                  <div className="flex items-center space-x-1 pt-2 pl-2">
                    <img
                      src="/docusensas-logo.svg"
                      alt="DocuSensa Logo"
                      className="w-[20.667px] h-[20.71px] flex-shrink-0"
                      style={{ fill: "#F5F4F3" }}
                    />{" "}
                    <h1 className="docu-design">DocuSensa</h1>
                  </div>

                  {/* Right side: Toggle button */}
                  <button
                    onClick={toggleMenu}
                    className="h-[32px] w-[32px] bg-white rounded-full mt-2 mr-2"
                  >
                    <img src={drawer} className="p-[5px]" />
                  </button>
                </div>
                <div className="border-b border-gray-500 my-4"></div>
              </div>
            ) : (
              <div className="flex flex-col gap-5 items-center justify-center">
                <button
                  onClick={toggleMenu}
                  className="h-[32px] w-[32px] bg-white rounded-full mt-2"
                >
                  <img src={TogglemenuClosed} className="p-[5px]" />
                </button>
                {isContractChat && (
                  <button className="bg-[#C95EBE] rounded-md p-1">
                    <img src="/chat-icon-nav.svg" alt="" />
                  </button>
                )}
                {isChatPage && (
                  <button className="bg-[#C95EBE] rounded-md p-1">
                    <img src="chat-icon-nav.svg" alt="" />
                  </button>
                )}
                {isFolderPage && (
                  <button className="bg-[#C95EBE] rounded-md p-1">
                    <img src="/chat-icon-nav.svg" alt="Folder Icon" />
                  </button>
                )}
                {isInvoiceChat && (
                  <button className="bg-[#C95EBE] rounded-md p-1">
                    <img src="/chat-icon-nav.svg" alt="Invoice Chat Icon" />
                  </button>
                )}
              </div>
            )}
          </div>

          {isOpen && (
            <aside className="w-[240px]  text-gray-100 h-[10rem] pl-[8px] pr-[8px] flex flex-col">
              {/* Navigation */}
              <nav className="flex-1">
                <ul>
                  {navItems.map((item, index) => (
                    <li key={index} className="mb-2">
                      {/* Main nav item container */}
                      <div
                        className={`flex items-center space-x-4 p-[10px] rounded-lg cursor-pointer transition-colors duration-200 
    ${
      isActive(item.link) || (item.subMenu && openSubMenuIndex === index)
        ? "bg-[#A04A97] border border-solid border-[rgba(0,0,0,0.1)]"
        : "hover:bg-[rgba(187,66,174,0.36)]"
    }
    ${
      item.title === "Rfp Manager" && !hasRfpAccess()
        ? "opacity-50 cursor-not-allowed"
        : ""
    }`}
                        onClick={() => handleSubMenuToggle(index)}
                      >
                        {/* Icon logic: show filled icon if active, otherwise show regular icon */}
                        {isActive(item.link) ||
                        (item.subMenu && openSubMenuIndex === index)
                          ? item.filledIcon || item.icon
                          : item.icon}

                        <Link to={item.link} className="flex-1">
                          {item.title}
                        </Link>

                        {item.subMenu && (
                          <span className="text-sm transition-transform duration-200">
                            {openSubMenuIndex === index ? (
                              <img
                                src="/up-arrows.svg"
                                alt="Up Arrow"
                                className="w-3 h-3 mt-1"
                              />
                            ) : (
                              <img
                                src="/up-arrows.svg"
                                alt="Down Arrow"
                                className="w-3 h-3 mt-1"
                              />
                            )}
                          </span>
                        )}
                      </div>

                      {/* Sub-menu */}
                      {item.subMenu && openSubMenuIndex === index && (
                        <ul className="relative mt-2 space-y-1 ml-8">
                          {/* Vertical line */}
                          <div className="absolute left-0 top-0 h-full w-0.5 bg-white rounded-full"></div>

                          {item.subMenu.map((subItem, subIndex) => (
                            <li key={subIndex} className="relative">
                              <Link
                                to={subItem.link}
                                className={`flex items-center space-x-2 block py-2 px-2 pl-4 rounded-lg transition-colors duration-200 ml-2
                        ${
                          isActive(subItem.link)
                            ? "bg-[rgba(187,66,174,0.36)]"
                            : "hover:bg-[rgba(187,66,174,0.36)]"
                        }`}
                              >
                                {/* Icon for sub-menu items */}
                                {isActive(subItem.link)
                                  ? subItem.filledIcon || subItem.icon
                                  : subItem.icon}
                                <span>{subItem.title}</span>
                              </Link>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              </nav>
            </aside>
          )}
        </div>
        {!isOpen && (
          <div className="flex flex-col flex-grow overflow-hidden relative">
            <ul className="text-white px-2 pt-4 overflow-y-auto">
              {navItems
                .filter(
                  (item) =>
                    !(
                      isChatPage &&
                      [
                        "AI Copilot",
                        "Documents",
                        "Contracts",
                        "Invoices",
                        "Spreadsheets",
                      ].includes(item.title)
                    )
                )
                .map((item, index) => (
                  <li
                    key={item.title}
                    className={`mb-3 cursor-pointer flex justify-start items-center h-10 ${
                      isOpen ? "w-[224px]" : "w-[56px]"
                    } relative`}
                    onClick={(e) => {
                      e.stopPropagation();
                      // When closed, click should open menu and go to the page
                      openMenuAndGo(item, index);
                    }}
                  >
                    {!isOpen &&
                    ![
                      "/contract/folderchat",
                      "/chat",
                      "/invoices/invoice_chat",
                      "/contract/contractchat",
                    ].includes(location.pathname.toLowerCase()) ? (
                      <div className="flex items-center pl-[22px] relative">
                        <div
                          className="relative"
                          onMouseEnter={(e) => {
                            const rect =
                              e.currentTarget.getBoundingClientRect();
                            setHoveredItem(index);
                            setTooltipPosition({
                              x: rect.left + rect.width / 2,
                              y: rect.top,
                            });
                          }}
                          onMouseLeave={() => setHoveredItem(null)}
                          onClick={(e) => {
                            e.stopPropagation();
                            openMenuAndGo(item, index);
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <h1 className="text-[20px]">
                            {isActive(item.link) ? item.filledIcon : item.icon}
                          </h1>
                        </div>
                      </div>
                    ) : null}
                  </li>
                ))}
            </ul>

            {/* Tooltip rendered OUTSIDE the scrollable area */}
            {hoveredItem !== null && (
              <div
                className="fixed bg-[#FEF9F7] text-[#52525B] text-[14px] font-[Outfit] font-normal border border-[rgba(0,0,0,0.1)] rounded-md shadow-lg px-3 py-1 z-[9999] whitespace-nowrap"
                style={{
                  top: `${tooltipPosition.y + 24}px`,
                  left: `${tooltipPosition.x + 20}px`,
                  transform: "translateY(-100%)",
                }}
              >
                {navItems[hoveredItem]?.title}
              </div>
            )}
          </div>
        )}

        {isOpen &&
          isPopupOpen &&
          !isDropdownOpen &&
          openSubMenuIndex === null && // 👈 hide popup if any submenu is open
          (subscriptionStatus?.subscription_type === "trial" ||
            subscriptionStatus?.subscription_type === "weekly_paid" ||
            (subscriptionStatus?.subscription_type === "paid_subs" &&
              subscriptionStatus?.plan_type === "monthly")) && (
            <div
              className="mx-3 my-4 p-4 text-[#2C1338] font-outfit text-sm flex flex-col justify-between transition-all duration-300"
              style={{
                width: "220px",
                height: "158px",
                flexShrink: 0,
                borderRadius: "12px",
                background:
                  "linear-gradient(111deg, #F5EEFF 14.52%, #FDFDFD 99.31%)",
                boxShadow:
                  "0px 18px 5px 0px rgba(255, 255, 255, 0.00), 0px 12px 5px 0px rgba(255, 255, 255, 0.01), 0px 7px 4px 0px rgba(255, 255, 255, 0.05), 0px 3px 3px 0px rgba(255, 255, 255, 0.09), 0px 1px 2px 0px rgba(255, 255, 255, 0.10)",
              }}
            >
              <div className="flex items-center mb-1">
                {!!isTrialActive && (
                  <img
                    src="/trial-icon-billing.svg"
                    alt="Trial Icon"
                    className="w-[16px] h-[16px] mr-2"
                  />
                )}
                <div
                  className="text-[#18101C] text-[13px] font-medium font-outfit"
                  style={{
                    letterSpacing: "0.13px",
                    lineHeight: "normal",
                  }}
                >
                  {!isTrialActive
                    ? "Maximize Your Potential with Grow Plan"
                    : `Trial Active: ${daysLeft} Days Left`}
                </div>
              </div>

              {!isTrialActive ? (
                <div
                  className="text-center font-outfit text-[13px] font-medium leading-none tracking-[0.13px]"
                  style={{ color: "#73607B" }}
                >
                  Save over{" "}
                  <span
                    style={{
                      background:
                        "linear-gradient(90deg, #F3904F 30.06%, #8B55DD 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    15% annually
                  </span>{" "}
                  compared to{" "}
                  <span
                    style={{
                      background:
                        "linear-gradient(90deg, #F3904F 30.06%, #8B55DD 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    Starter Plan!
                  </span>
                </div>
              ) : (
                <div
                  className="text-center font-outfit text-[13px] font-medium leading-none tracking-[0.13px]"
                  style={{ color: "#73607B" }}
                >
                  Upload up to{" "}
                  <span
                    style={{
                      background:
                        "linear-gradient(90deg, #F3904F 30.06%, #8B55DD 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    {subscriptionStatus?.upload_limit ?? 5} documents
                  </span>{" "}
                  and perform{" "}
                  <span
                    style={{
                      background:
                        "linear-gradient(90deg, #F3904F 30.06%, #8B55DD 100%)",
                      WebkitBackgroundClip: "text",
                      WebkitTextFillColor: "transparent",
                    }}
                  >
                    unlimited AI queries daily
                  </span>
                </div>
              )}

              <div className="mt-2 text-center">
                <div className="text-[12px] mb-1 text-[#2C1338]">
                  Need more power?
                </div>
                <button
                  onClick={() =>
                    navigate("/account", { state: { defaultTab: "billing" } })
                  }
                  className="inline-flex justify-center items-center gap-[10px] rounded-[6px] transition font-outfit text-[13px] font-medium leading-none tracking-[0.13px] text-center"
                  style={{
                    padding: "8px 20px",
                    background:
                      "linear-gradient(93deg, #6F52ED 0.64%, #845EC2 99.52%)",
                    color: "#F5F4F3",
                  }}
                >
                  Upgrade Now
                </button>
              </div>
            </div>
          )}
        {isDropdownOpen && (
          <div
            className={`absolute bottom-[90px] left-1/2 transform -translate-x-1/2 ${
              isOpen ? "w-[224px]" : "w-[70px]"
            } bg-[#2C1338] rounded-[6px] border border-[rgba(254,249,247,0.20)] shadow-[0px_4px_4px_rgba(0,0,0,0.25)] z-50`}
          >
            <ul
              className={`list-none  ${
                isOpen
                  ? "p-[8px] flex flex-col gap-[4px] justify-start"
                  : "p-[8px] flex flex-col gap-[12px] justify-center"
              }`}
            >
              {boxItems.map((item, index) => (
                <li
                  key={item.id}
                  onClick={() => handleBoxClick(index)}
                  className={`text-white flex items-center ${
                    isOpen
                      ? `w-[208px] justify-start gap-[8px]`
                      : `w-[54px] justify-center`
                  } h-[32px] rounded-[6px] p-0 cursor-pointer overflow-hidden transition-all ease-in-out duration-300 ${
                    isOpen
                      ? clickedBox === index
                        ? "border-t-[0.5px] border-r-[0.5px] border-b-[3px] border-l-[0.5px] border-white bg-[#ffffff20] px-[12px] py-[6px]"
                        : "border-transparent bg-transparent px-[12px] py-[6px] hover:bg-[#633168] hover:text-white"
                      : "p-[4px] hover:bg-[#A04A97] hover:text-white"
                  }`}
                >
                  <img
                    src={item.icon}
                    alt={`${item.label} Icon`}
                    style={{
                      width: !isOpen ? "20px" : "16px",
                      height: !isOpen ? "20px" : "16px",
                    }}
                  />
                  {isOpen && <span>{item.label}</span>}
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="pb-2 flex flex-col gap-4">
          {location.pathname.toLowerCase() !== "/chat" &&
            location.pathname.toLowerCase() !== "/invoice_chat" &&
            location.pathname.toLowerCase() !== "/contractchat" &&
            location.pathname.toLowerCase() !== "/Contract/FolderChat" && (
              <div className={`flex ${isOpen ? 'justify-center gap-2' : 'justify-center'} items-center text-white`}>
              <div>
                <img src={profile} alt="profile logo" />
              </div>
              {isOpen && (
                <div>
                  <div className="text-base mt-2">{displayName}</div>
                  <div className="text-xs text-gray-400">{user.email}</div>
                </div>
              )}
            
              <div>
                <img
                  src={arrowUp}
                  alt="arrow-up"
                  className="cursor-pointer"
                  style={{
                    transform: isDropdownOpen ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.3s",
                  }}
                  onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                />
              </div>
            </div>
            
            )}
        </div>
      </nav>
      {isShowPaymentPopup &&
        subscriptionStatus?.subscription_type?.toLowerCase() !==
          "paid_subs" && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg p-3 w-[360px] text-center">
              {(() => {
                const type = (
                  subscriptionStatus?.subscription_type || ""
                ).toLowerCase();
                const expiredType = (
                  subscriptionStatus?.expired_or_cancelled_subscription
                    ?.subscription_type || ""
                ).toLowerCase();

                if (
                  type === "subscription_expired" &&
                  expiredType === "subscription_expired"
                ) {
                  return (
                    <>
                      <h2 className="text-lg font-semibold mb-4">
                        🔒 Subscription Expired
                      </h2>
                      <p className="text-sm text-gray-600 mb-6">
                        Your subscription has expired. Please renew to continue
                        using premium features.
                      </p>
                    </>
                  );
                } else if (type === "trial_expired" || type === "none") {
                  return (
                    <>
                      <h2 className="text-lg font-semibold mb-4">
                        🚀 Your Trial Has Ended
                      </h2>
                      <p className="text-sm text-gray-600 mb-6">
                        Your free trial has ended. To continue enjoying premium
                        features, please upgrade your subscription. 💎
                      </p>
                    </>
                  );
                } else {
                  return (
                    <>
                      <h2 className="text-lg font-semibold mb-4">
                        ⚠️ Subscription Inactive
                      </h2>
                      <p className="text-sm text-gray-600 mb-6">
                        We were unable to verify your subscription status.
                        <br />
                        To continue accessing premium features, please upgrade
                        your plan or contact our support team for assistance.
                      </p>
                    </>
                  );
                }
              })()}
              <div className="flex justify-between gap-3 mt-4">
                {/* Logout - left side */}
                <button
                  onClick={handleLogout}
                  className="flex-1 border  text-[#C95EBE] bg-white px-4 py-2 rounded-[6px] font-semibold text-sm hover:bg-[#C95EBE] hover:text-white active:bg-[#A844A7] transition-colors duration-300"
                >
                  🔓 Logout
                </button>

                {/* Upgrade Now - right side */}
                <button
                  onClick={() => navigate("/payment")}
                  className="flex-1 border  text-[#C95EBE] bg-white px-4 py-2 rounded-[6px] font-semibold text-sm hover:bg-[#C95EBE] hover:text-white active:bg-[#A844A7] transition-colors duration-300"
                >
                  🔁 Upgrade Now
                </button>
              </div>
            </div>
          </div>
        )}

      {showGetStarted && (
        <div className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm flex items-center justify-center">
          <img
            src="/leftside-celebration.svg"
            alt="celebration left"
            style={{
              position: "absolute",
              top: "50%",
              left: "32rem",
              transform: "translateY(-50%)",
              zIndex: 1,
            }}
          />
          <img
            src="/right-side-celebration.svg"
            alt="celebration right"
            style={{
              position: "absolute",
              top: "50%",
              left: "49rem",
              transform: "translateY(-50%)",
              zIndex: 1,
            }}
          />
          <div className="activation-popup">
            <img
              src="/celebrate-icon.svg"
              alt="confetti"
              className="confetti-icon"
            />
            <h2>You're all set!</h2>
            <p>
              Ready to unlock the full potential of your documents?
              <br />
              Your 14-day free trial starts now!
            </p>
            <button
              className="activating-btn"
              onClick={() => {
                setShowGetStarted(false);
                window.location.href = "/ai-Copilot";
              }}
            >
              Get Started Now
            </button>
          </div>
        </div>
      )}
    </div>
  );
};
export default Menu;